import React from 'react';

export const FocusIcon = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.5 11C5.5 11.2761 5.72386 11.5 6 11.5C6.27614 11.5 6.5 11.2761 6.5 11V8.95852C7.75625 8.74776 8.74776 7.75625 8.95852 6.5H11C11.2761 6.5 11.5 6.27614 11.5 6C11.5 5.72386 11.2761 5.5 11 5.5H8.95852C8.74776 4.24375 7.75625 3.25224 6.5 3.04148V1C6.5 0.723858 6.27614 0.5 6 0.5C5.72386 0.5 5.5 0.723858 5.5 1V3.04148C4.24375 3.25224 3.25224 4.24375 3.04148 5.5H1C0.723858 5.5 0.5 5.72386 0.5 6C0.5 6.27614 0.723858 6.5 1 6.5H3.04148C3.25224 7.75625 4.24375 8.74776 5.5 8.95852V11ZM6 8C4.89543 8 4 7.10457 4 6C4 4.89543 4.89543 4 6 4C7.10457 4 8 4.89543 8 6C8 7.10457 7.10457 8 6 8Z"
            fill="#6A7EA7"
        />
    </svg>
);
